import { defineMessages } from '@jutro/locale';

export default defineMessages({
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ'
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error'
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try again later or contact us.',
        defaultMessage: 'Sorry, an error occurred. You can try again later or contact us.'
    },
    searchPlaceHolder: {
        id: 'gateway.views.search-quote.Search by account or policy number.',
        defaultMessage: 'Search by account or policy number...',
    },
    login: {
        id: 'auth.components.AuthStatus.Login',
        defaultMessage: 'Login',
    },
    account: {
        id: 'auth.components.AuthStatus.Account',
        defaultMessage: 'Account',
    },
    preferences: {
        id: 'auth.components.AuthStatus.Preferences',
        defaultMessage: 'Preferences',
    },
    logOut: {
        id: 'auth.components.AuthStatus.Log out',
        defaultMessage: 'Log out',
    },
    quoteAnyAccount: {
        id: 'gateway.views.new-quote.Quote for Any Account',
        defaultMessage: 'Quote for Any Account'
    },
    quoteThisAccount: {
        id: 'gateway.views.new-quote.Quote for This Account',
        defaultMessage: 'Quote for This Account'
    },
    viewAll: {
        id: 'gateway.views.new-quote.View all',
        defaultMessage: 'View all matches of number: {Number}',
    },
    accountsTab: {
        id: 'app.html.index.Accounts',
        defaultMessage: 'Accounts',
    },
    policiesTab: {
        id: 'app.html.index.Policies',
        defaultMessage: 'Policies',
    },
    claimsTab: {
        id: 'app.html.index.Claims',
        defaultMessage: 'Claims',
    },
    activitiesTab: {
        id: 'app.html.index.Activities',
        defaultMessage: 'Activities',
    },
    commissionTab: {
        id: 'app.html.index.Commission',
        defaultMessage: 'Commission',
    },
});
